import { useState, useEffect, useRef } from "react";
import {
  Grid,
  TextField,
  Button,
  FormControl,
  Autocomplete,
  DataGrid,
  CurrencyInput,
  Tooltip,
  IconButton,
  DocumentoProdutoAplicacaoDialog,
  TextFielDecimalNumbers,
  ProdutoEstoqueInformacaoDialog,
  OrdemCompraDialog,
  ListBoxAutocomplete,
  Typography,
} from "../../../../../components";
import {
  ProdutosService,
  SessionService,
  UnidadeComercialService,
  notification,
} from "../../../../../services";
import { PermisoesHelper, value } from "../../../../../helpers";
import { ProdutoSimilarDialog } from "../../components";
import {
  responseErros,
  formatPrice,
  unformatPrice,
  timeoutBuscaAutocomplete,
  formatPrecisaoFloat,
} from "../../../../../utils";
import shortid from "shortid";
import { calcularPrecoProduto, calculoDesconto, validarTabelaTodosProdutosMeioPagamento, validarTabelaVendaCliente, validarTabelaVendaMeioPagamento } from "../../addPedidos";
import TabelaCustoDialog from "../../../../../components/tabela-custo-dialog/tabela-custo-dialog.component";

const PedidosItens = ({
  id,
  pedido,
  setPedido,
  setLoading,
  loadingAutoCompleteProduto,
  setLoadingAutoCompleteProduto,
  produtoList,
  setProdutoList,
  produto,
  setProduto,
  listaPedidosProdutos,
  setListaPedidosProdutos,
  setListaPedidosPagamentos,
  tabelas,
  removerProdutoCadastrado,
  calcularValorTotal,
  buscarProdutosSimilares,
  produtosSimilares,
  setProdutosSimilares,
  permitirVendaEstoqueNegativo,
  origensMercadoriasList,
  listaUnidadesComerciais,
  setListaUnidadesComerciais,
  pedidoEntity,
  meioPagamentoSelecionado,
  acrescimoPagamento,
  tabelasTodosProdutos
}) => {
  const inputRef = useRef();
  const unidadeComercialService = new UnidadeComercialService();
  const produtosService = new ProdutosService();
  const [isProdutoEdit, setIsProdutoEdit] = useState(false);
  const [openProdutoSimilarDialog, setOpenProdutoSimilarDialog] =
    useState(false);
  const [
    openProdutoEstoqueInformacaoDialog,
    setOpenProdutoEstoqueInformacaoDialog,
  ] = useState(false);
  const [itensColumnView, setItensColumnView] = useState(false);
  const [openProdutoAplicacoesDialog, setOpenProdutoAplicacoesDialog] =
    useState(false);
  const [produtosTabelaCusto, setProdutosTabelaCusto] = useState([]);
  const [totaisTabelaCusto, setTotaisTabelaCusto] = useState([]);
  const [openTabelaCustoDialog, setOpenTabelaCustoDialog] = useState(false);
  const [openOrdemCompraDialog, setOpenOrdemCompraDialog] = useState(false);

  const permissoesHelper = new PermisoesHelper();
  const tabelaCustoPermissao = permissoesHelper.temPermisao(
    "tabela-custo-visualizar"
  );
  const ordemCompraPermissao = permissoesHelper.temPermisao(
    "ordem-compra-visualizar"
  );

  const sessionService = new SessionService();
  const { configuracoes } = sessionService.getEmpresa();
  const usuario = sessionService.getUsuario();

  const colunas = [
    {
      field: "codigo",
      headerName: "Código",
      flex: 100,
    },
    {
      field: "descricao",
      headerName: "Produto",
      flex: 500,
    },
    {
      field: "quantidade",
      headerName: "Qtd.",
      flex: 90,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        Number.isInteger(parseFloat(params.value))
          ? params.value
          : params.value.toFixed(3).replace(".", ","),
    },
    {
      field: "valorUnitario",
      headerName: "Unitário (R$)",
      flex: 200,
      headerAlign: "right",
      align: "right",
      valueGetter: (params) => formatPrice(parseFloat(params.value)),
    },
    {
      field: "totalItem",
      headerName: "Subtotal (R$)",
      flex: 180,
      headerAlign: "right",
      align: "right",
      valueGetter: (params) =>
        params.value ? formatPrice(parseFloat(params.value)) : "",
    },
    {
      field: "desconto",
      headerName: "Desconto (R$)",
      flex: 150,
      headerAlign: "right",
      align: "right",
      valueGetter: (params) => formatPrice(parseFloat(params.value)),
    },
    {
      field: "total",
      headerName: "Total (R$)",
      flex: 180,
      headerAlign: "right",
      align: "right",
      valueGetter: (params) => {
        return formatPrice(
          parseFloat(params.row.totalItem) -
            parseFloat(params.row.desconto || 0) +
            parseFloat(params.row.despesas || 0)
        );
      },
    },
    {
      field: "acoes",
      headerName: "Ações",
      sortable: false,
      flex: 100,
      align: "center",
      headerAlign: "center",
      disableClickEventBubbling: true,
      renderCell: (params) => {
        return (
          <div>
            {!params.row.origemKitId && (
              <IconButton
                onClick={() => {
                  onClickEditPedidosItens(params.id);
                }}
              >
                <Tooltip title="Editar" arrow placement="right">
                  <i className="ph-fill ph-pencil" style={{ fontSize: 18 }}></i>
                </Tooltip>
              </IconButton>
            )}
            <IconButton
              onClick={(event) => {
                event.stopPropagation();
                onClickDeletePedidosItens(params.id);
              }}
            >
              <Tooltip title="Excluir" arrow placement="right">
                <i className="ph-fill ph-trash" style={{ fontSize: 18 }}></i>
              </Tooltip>
            </IconButton>
          </div>
        );
      },
    },
  ];

  const produtosColunasSimilares = [
    {
      field: "codigo",
      headerName: "Cod.",
      flex: 280,
    },
    {
      field: "descricao",
      headerName: "Produtos",
      flex: 700,
    },
    {
      field: "estoqueAtual",
      headerName: "Estoque",
      flex: 350,
    },
    {
      field: "precoVenda",
      headerName: "Preço Venda",
      flex: 500,
      valueGetter: (params) => formatPrice(params.value),
    },
    {
      field: "acoes",
      sortable: false,
      disableClickEventBubbling: true,
      renderHeader: () => {
        return (
          <i
            className="ph-fill ph-note-pencil"
            style={{ fontSize: 20, marginLeft: 14 }}
          ></i>
        );
      },
      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => {
              if (params.row) {
                setOpenProdutoSimilarDialog(false);
                setProdutosSimilares([]);
                handleChangeAutocompleteProduto(params.row, false, true);
              }
            }}
            sx={{
              "&:hover": { backgroundColor: "transparent" },
            }}
          >
            <i
              className="ph-fill ph-paper-plane-right"
              style={{ fontSize: 20, marginLeft: 14 }}
            ></i>
          </IconButton>
        );
      },
    },
  ];

  const buscarUnidadesComerciais = () => {
    if (listaUnidadesComerciais?.length) return;
    unidadeComercialService.getAll().then((res) => {
      if (!res.isAxiosError) {
        setListaUnidadesComerciais(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const onClickDeletePedidosItens = async function (idProduto) {
    const retornoAlerta = await notification.confirmacao(
      "Excluir!",
      `Tem certeza que deseja excluir essa conta?`
    );
    let listaItens = [];
    const produto = listaPedidosProdutos.find(
      (produto) => produto.id == idProduto
    );
    if (retornoAlerta.isConfirmed) {
      if (id) {
        if (produto.origemKitId) {
          listaItens = listaPedidosProdutos
            .filter((item) => item.origemKitId === produto.origemKitId)
            .map(({ id }) => id);
        } else {
          listaItens.push(idProduto);
        }
        removerProdutoCadastrado({ idItens: listaItens });
      } else {
        if (produto.origemKitId) {
          listaItens = listaPedidosProdutos.filter(
            (item) => item.origemKitId !== produto.origemKitId
          );
        } else {
          listaItens = listaPedidosProdutos.filter(
            (produto) => produto.id != idProduto
          );
        }
        setListaPedidosProdutos(listaItens);
        pedidoEntity.setChangeItens(listaItens);
        setPedido(pedidoEntity);
      }
    }
  };

  const buscarProdutos = (
    filtros,
    isProdutoSimilar = false,
    isCodigoBarras = false
  ) => {
    const filtro = {
      ...filtros,
      orderBy: "codigo",
      order: "asc",
      ativado: true,
      tabelasVenda: true,
      limite: 20,
    };
    produtosService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setLoadingAutoCompleteProduto(false);
        if (isProdutoSimilar && result.data.rows?.length) {
          const itens = result.data.rows.map((item) => {
            const { informacao, ...rest } = item;
            const produtoResultante = { ...rest, ...informacao, id: rest.id };
            const unidadeProduto = listaUnidadesComerciais.find(
              (unidade) =>
                unidade.id == produtoResultante.unidadeComercialVendaId
            );
            return montarItem({ ...produtoResultante, unidadeProduto }, false);
          });
          setProdutosSimilares(itens);
          setLoading(false);
          return;
        }

        if (isCodigoBarras) {
          handleChangeAutocompleteProduto(result.data.rows[0], true);
        } else {
          setProdutoList(result.data.rows);
        }
      } else {
        setLoadingAutoCompleteProduto(false);
        responseErros(result);
      }
    });
  };

  const buscarProdutoKit = async (produtoId) => {
    if (produtoId) {
      const result = await produtosService.getById(produtoId);
      if (!result.isAxiosError) {
        return result.data;
      } else {
        responseErros(result);
      }
    }
  };

  const buscarProdutosByCodigo = async (codigoBarra, valorProduto) => {
    const result = await produtosService.getAllProdutosByCodigo({
      codigoBarra,
    });
    if (!result.isAxiosError) {
      setLoadingAutoCompleteProduto(false);
      if (result.data.length === 0) return;
      let produto = result.data[0];
      let quantidade = null;
      if (valorProduto) {
        quantidade =
          Math.round((valorProduto / produto.informacao.precoVenda) * 1000) /
          1000;
      }
      produto = {
        ...produto,
        quantidade,
        totalItem: valorProduto,
      };
      handleChangeAutocompleteProduto(produto, true, !!valorProduto);
      setLoading(false);
    } else {
      setLoadingAutoCompleteProduto(false);
      responseErros(result);
    }
  };

  const onInputChangeProdutos = (event) => {
    const eventValue = event.target?.value.includes(",")
      ? event.target?.value.split(",")[0]
      : event.target?.value;
    if (
      event.key === "Backspace" &&
      inputRef.current === document.activeElement &&
      eventValue === ""
    ) {
      setProdutoList([]);
    }
    if (event.key === "Enter" && inputRef.current === document.activeElement) {
      const filtros = {
        codigo: eventValue,
        descricao: eventValue,
        codigoBarra: eventValue,
      };
      const validacaoCodigoNumerico = Number.isFinite(parseFloat(eventValue));
      const isCodigoBalanca =
        configuracoes.inicialCodigoBarrasBalanca ===
          parseFloat(eventValue[0]) && eventValue.length >= 7;
      setLoadingAutoCompleteProduto(true);
      if (
        validacaoCodigoNumerico &&
        (configuracoes.buscaProdutosCodigoBarras || isCodigoBalanca)
      ) {
        const codigo = isCodigoBalanca ? eventValue.slice(0, 7) : eventValue;
        let valorProduto = null;
        if (isCodigoBalanca && eventValue.length >= 12) {
          valorProduto =
            parseInt(eventValue.slice(7, 12).replace(/^0+/, "")) / 100;
        }
        timeoutBuscaAutocomplete(buscarProdutosByCodigo(codigo, valorProduto));
      } else {
        const isCodigoBarras =
          validacaoCodigoNumerico && eventValue.length >= 8;
        timeoutBuscaAutocomplete(
          buscarProdutos(filtros, false, isCodigoBarras)
        );
      }
    }
  };

  useEffect(() => {
    buscarUnidadesComerciais();
  }, []);

  function verificaEstoque(produto) {
    if (!permitirVendaEstoqueNegativo) {
      const estoque = produto?.estoqueProduto?.estoque;
      if (!estoque || estoque < 0) {
        if (usuario.acessosEmpresas?.length > 1) return true;
        notification.alertaGenericos("Produto fora de estoque");
        setProduto(null);
        return true;
      }
    }
    return false;
  }

  const handleChangeAutocompleteProduto = (
    produtoEscolhido,
    isBuscaCodBar = false,
    isLeituraBalanca = false
  ) => {
    document.getElementById("produtoId").blur();
    if (produtoEscolhido) {
      const { informacao, ...rest } = produtoEscolhido;
      let produtoResultante = { ...rest, ...informacao, id: rest.id };
      if (produtoEscolhido.tipo === "kit") {
        produtoResultante = {
          ...produtoResultante,
          desconto: null,
          descontoPorcentagem: null,
          frete: null,
          despesas: null,
        };
      }
      const estoque = verificaEstoque(produtoResultante);
      if (estoque && usuario.acessosEmpresas?.length === 1) return;
      const unidadeProduto = listaUnidadesComerciais.find(
        (unidade) => unidade.id == produtoResultante.unidadeComercialVendaId
      );
      const itemTemp = montarItem(
        {
          ...produtoResultante,
          unidadeProduto,
        },
        true,
        isLeituraBalanca
      );
      setProduto(itemTemp);
      if (produtoResultante.similares?.length && !isBuscaCodBar) {
        const listaIdsProdutosSimilares = produtoResultante.similares.map(
          ({ similarId }) => similarId
        );
        setLoading(true);
        buscarProdutos({ id: listaIdsProdutosSimilares }, true);
      }
      if (usuario.acessosEmpresas?.length > 1 && estoque) {
        openEstoqueDialog(produtoResultante);
      } else if (!isBuscaCodBar) {
        document.getElementById("buttonAdicionar").focus();
      } else {
        handleAdicionarProduto(itemTemp);
      }
    } else {
      setProdutosSimilares([]);
      setProduto(null);
    }
  };

  const montarItem = (
    produtoResultante,
    insertItem = true,
    isLeituraBalanca = false
  ) => {
    const valorUnitario =
      acrescimoPagamento && !isLeituraBalanca
        ? produtoResultante.precoVenda +
          formatPrecisaoFloat(
            produtoResultante.precoVenda * (acrescimoPagamento / 100)
          )
        : produtoResultante.precoVenda;
    const quantidade = produtoResultante.quantidade ?? 1;
    const totalItem = produtoResultante.totalItem ?? valorUnitario * quantidade;
    let itemTemp = {
      ...produtoResultante,
      quantidade,
      unidade: produtoResultante.unidadeProduto
        ? produtoResultante.unidadeProduto?.codigo
        : "",
      estoqueAtual: produtoResultante?.estoqueProduto?.estoque
        ? `${produtoResultante.estoqueProduto.estoque}`
        : 0,
      produtoId: produtoResultante?.produtoId || produtoResultante.id,
      descricao: produtoResultante?.descricao || "",
      codigo: produtoResultante?.codigo,
      tributosIcmsOrigem: origensMercadoriasList.find(
        (item) => item.id == produtoResultante.origemMercadoriaId
      )?.codigo,
      ncm: produtoResultante?.ncmCodigo,
      valorUnitario,
      totalItem,
    };
    if (insertItem) {
      itemTemp = { ...produto, ...itemTemp };
    }
    let resultItem = { ...itemTemp };

    const tabelaTodosProdutos = validarTabelaTodosProdutosMeioPagamento(
      tabelasTodosProdutos, 
      meioPagamentoSelecionado?.id
    );
    if (
      validarTabelaVendaCliente(
        tabelas?.cliente, 
        resultItem.produtoId
      )
    ) {
      resultItem = calcularPrecoProduto(
        resultItem,
        tabelas?.cliente,
      );
    } else if (tabelas?.grupoPessoa) {
      resultItem = calcularPrecoProduto(
        resultItem,
        tabelas?.grupoPessoa,
      );
    } else if (
      validarTabelaVendaMeioPagamento(
        produtoResultante?.tabelasVenda, 
        meioPagamentoSelecionado?.id
    )) {
      resultItem = calcularPrecoProduto(
        resultItem,
        resultItem?.tabelasVenda[0] || {},
        "meioPagamento"
      );
    } else if (tabelaTodosProdutos) {
      resultItem = calcularPrecoProduto(
        resultItem,
        tabelaTodosProdutos,
      );
    } 
    return resultItem;
  };

  const handleInputChange = (event) => {
    const produtoTemp = {
      ...produto,
      [event.target.name]: event.target.value || null,
    };
    produtoTemp.totalItem = calcularValorTotal(produtoTemp);
    setProduto(produtoTemp);
  };

  const handleInputBlur = (event) => {
    const { name, value } = event.target;
    const valor = parseFloat(unformatPrice(value));
    let produtoTemp = {
      ...produto,
      [name]: valor || null,
    };
    if (
      acrescimoPagamento &&
      name === "valorUnitario" &&
      valor !== produto.valor
    ) {
      produtoTemp.valorUnitario = formatPrecisaoFloat(
        valor + (valor * acrescimoPagamento) / 100
      );
    }
    const total = calcularValorTotal(produtoTemp);
    if (name === "valorUnitario" || name === "quantidade") {
      produtoTemp.desconto = produto?.descontoPorcentagem
        ? (total * produto.descontoPorcentagem) / 100
        : null;
    }
    produtoTemp.totalItem = total;
    setProduto(produtoTemp);
  };

  const onClickEditPedidosItens = async (id) => {
    const item = listaPedidosProdutos.find((item) => item.id === id);
    if (item) {
      setIsProdutoEdit(true);
    }
    setProduto(item);
  };

  const validarAddProduto = (produto) => {
    if (!produto) {
      notification.alertaGenericos("Selecione um produto para adicionar");
      return true;
    }
    if (!produto.quantidade) {
      notification.erroValidacao("Quantidade do produto");
      return true;
    }
    if (!produto.unidade) {
      notification.erroValidacao("Unidade do produto");
      return true;
    }
  };

  const handleInputDesconto = (event) => {
    if (!produto) return;
    const valor = unformatPrice(event.target.value);

    const itemTemp = {
      ...produto,
      [event.target.name]: valor || 0,
    };
    if (event.target.name === "desconto") {
      const subtotal = itemTemp.valor * itemTemp.quantidade;
      if (parseFloat(itemTemp.desconto) > subtotal) {
        itemTemp.desconto = subtotal;
      }
      itemTemp.descontoPorcentagem = calculoDesconto(
        [produto],
        itemTemp,
        false
      );
      setProduto(itemTemp);
    } else {
      itemTemp.desconto = calculoDesconto([produto], itemTemp);
      setProduto(itemTemp);
    }
  };

  const handleAdicionarProduto = async (produto) => {
    if (validarAddProduto(produto)) return;
    let listaItens = [];
    if (isProdutoEdit) {
      const produtoIndex = listaPedidosProdutos.findIndex(
        (item) => item.id === produto.id
      );
      listaItens = listaPedidosProdutos.map((item, _index) =>
        _index === produtoIndex
          ? {
              ...item,
              ...produto,
            }
          : item
      );
    } else {
      if (produto.tipo === "kit" && produto.envioKitItensFiscal) {
        const result = await buscarProdutoKit(produto.id);
        const kitItens = result.kits.map((item) => {
          const itemProduto = item.produto;
          const quantidade = produto.quantidade * item.quantidade;
          const unidadeProduto = listaUnidadesComerciais.find(
            (unidade) => unidade.id == itemProduto.unidadeComercialVendaId
          );
          return {
            ...itemProduto,
            quantidade,
            valorUnitario: itemProduto.informacao.precoVenda,
            totalItem: quantidade * itemProduto.informacao.precoVenda,
            origemKitId: result.id,
            produtoId: itemProduto.id,
            ncm: itemProduto.informacao.ncmCodigo,
            unidade: unidadeProduto ? unidadeProduto?.codigo : "",
            tributosIcmsOrigem: origensMercadoriasList.find(
              (item) => item.id == itemProduto.origemMercadoriaId
            )?.codigo,
            id: shortid.generate(),
          };
        });
        listaItens = [...listaPedidosProdutos, ...kitItens];
      } else {
        listaItens = [
          ...listaPedidosProdutos,
          {
            ...produto,
            id: shortid.generate(),
          },
        ];
      }
    }
    setListaPedidosPagamentos([]);
    setListaPedidosProdutos(listaItens);
    pedidoEntity.setChangeItens(listaItens);
    setPedido(pedidoEntity);
    document.getElementById("produtoId").focus();
    setIsProdutoEdit(false);
    setProduto(null);
    setProdutoList([]);
    setProdutosSimilares([]);
  };

  const handleAddActionsOpen = () => {
    if (!produto) {
      return notification.alertaGenericos("Selecione um produto");
    }
    setItensColumnView(!itensColumnView);
  };

  const openProdutoSimilar = () => {
    if (produto === null) {
      notification.alertaGenericos(
        "Selecione um produto primeiro para colocar produto similar"
      );
    } else {
      setOpenProdutoSimilarDialog(true);
    }
  };

  const openAplicacoesDialog = () => {
    if (produto === null) {
      notification.alertaGenericos(
        "Selecione um produto primeiro para colocar produto similar"
      );
    } else {
      setOpenProdutoAplicacoesDialog(true);
    }
  };

  const openEstoqueDialog = (produtoEscolhido = produto) => {
    if (produtoEscolhido === null) {
      notification.alertaGenericos("Selecione um produto primeiro");
    } else {
      setOpenProdutoEstoqueInformacaoDialog(true);
    }
  };

  const handleOpenTabelaCustoDialog = () => {
    const produtosTabelaCusto = listaPedidosProdutos.map((item) => {
      const quantidade = item.quantidade || 0;
      const precoCusto = item.precoCusto || 1;
      const precoVenda = item.totalItem || 1;
      const totalCustoItem = precoCusto * quantidade;
      const diferenca = ((precoVenda - totalCustoItem) / totalCustoItem) * 100;
      return {
        ...item,
        total: formatPrice(totalCustoItem, false),
        dif: formatPrice(diferenca, false),
      };
    });
    let totaisTabelaCusto = { totalCusto: 0, totalVenda: 0 };
    listaPedidosProdutos.forEach((item) => {
      const totalCusto =
        totaisTabelaCusto.totalCusto +
        (item.precoCusto || 0) * (item.quantidade || 0);
      const totalVenda = totaisTabelaCusto.totalVenda + item.totalItem || 0;
      totaisTabelaCusto.totalCusto = Math.round(totalCusto * 100) / 100;
      totaisTabelaCusto.totalVenda = Math.round(totalVenda * 100) / 100;
    });

    const totalDif =
      totaisTabelaCusto.totalVenda - totaisTabelaCusto.totalCusto;
    totaisTabelaCusto = {
      ...totaisTabelaCusto,
      totalDif: formatPrice(totalDif, false),
      percentualDif: formatPrice(
        (totalDif / totaisTabelaCusto.totalCusto) * 100,
        false
      ),
    };

    setProdutosTabelaCusto(produtosTabelaCusto);
    setTotaisTabelaCusto(totaisTabelaCusto);
    setOpenTabelaCustoDialog(true);
  };

  const renderSizeItemAutocomplete = () => {
    if (produtosSimilares?.length || produto?.aplicacoes?.length) {
      if (produtosSimilares?.length && produto?.aplicacoes?.length) {
        return 4.5;
      } else {
        return 5;
      }
    } else {
      return 5.5;
    }
  }

  return pedido.status === "CANCELADO" || pedido.status === "FECHADO" ? (
    <DataGrid
      rows={listaPedidosProdutos}
      rowCount={listaPedidosProdutos.length}
      columns={colunas}
    />
  ) : (
    <Grid container className="position-relative">
      <Grid
        container
        spacing={2}
        className="mb-2"
        alignItems="center"
        justifyContent="space-between"
        columns={15}
      >
        <Grid
          item
          xs={15}
          md={renderSizeItemAutocomplete()}
        >
          <FormControl variant="outlined" margin="normal" fullWidth>
            <Autocomplete
              ListboxComponent={ListBoxAutocomplete}
              id="produtoId"
              name="produtoId"
              options={produtoList}
              autoHighlight
              disabled={id && pedido.status !== "ABERTO"}
              loading={loadingAutoCompleteProduto}
              loadingText="Carregando"
              noOptionsText="Digite e clique no ícone para buscar"
              renderOption={(props, option) => {
                let descricaoProduto = `${option?.codigo} - ${option?.descricao}`;
                return option ? (
                  <li {...props} style={{ background: "transparent" }}>
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <div>
                        <span className="fw-bold">{descricaoProduto}</span>
                        <div className="d-flex gap-3">
                          <Typography variant="body2">
                            Unidade:{" "}
                            {
                              value.autoComplete(
                                listaUnidadesComerciais || [],
                                option?.unidadeComercialVendaId
                              ).codigo
                            }
                          </Typography>
                          <Typography variant="body2">
                            Cód.barra: {option?.codigoBarra}
                          </Typography>
                        </div>
                        <Typography variant="body2" className="fw-bolder">
                          Estoque disponível:{" "}
                          <span
                            className={
                              option?.estoqueProduto?.estoque < 0
                                ? "text-danger"
                                : "text-success"
                            }
                          >
                            {option?.estoqueProduto?.estoque}
                          </span>
                        </Typography>
                      </div>
                      <div className="text-end">
                        <Typography variant="body2">Preço venda</Typography>
                        <span className="fs-6">
                          {formatPrice(option?.informacao?.precoVenda || 0)}
                        </span>
                      </div>
                    </div>
                  </li>
                ) : (
                  ""
                );
              }}
              getOptionLabel={(option) => {
                let descricaoProduto = `${option?.codigo} - ${option?.descricao}`;
                return option ? descricaoProduto : "";
              }}
              filterSelectedOptions
              onChange={(_, value) => handleChangeAutocompleteProduto(value)}
              value={produto ?? ""}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Buscar produto"
                  required
                  onKeyDown={(e) => onInputChangeProdutos(e)}
                  inputRef={inputRef}
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
            />
          </FormControl>
        </Grid>
        <Grid item xs={0.5} sx={{ mt: "0.5em" }}>
          <Tooltip title="Estoque e Informação do Item" placement="bottom">
            <Button
              id="buttonEstoqueInformacaoItem"
              variant="contained"
              color="primary"
              disabled={
                id || !pedido?.operacaoFiscalId ? true : false || !produto
              }
              size="small"
              sx={{
                height: "35px",
                borderRadius: "20%",
                minWidth: "15px",
                boxShadow: "none",
              }}
              onClick={() => openEstoqueDialog()}
            >
              <i
                className="ph-fill ph-package"
                style={{ color: "#fff", fontSize: 15 }}
              ></i>
            </Button>
          </Tooltip>
        </Grid>
        {produto?.aplicacoes?.length ? (
          <Grid item xs={0.5} sx={{ mt: "0.5em" }}>
            <Tooltip title="Aplicações do item" placement="bottom">
              <Button
                id="buttonAplicacoesItem"
                variant="contained"
                color="primary"
                disabled={id || !pedido?.operacaoFiscalId}
                size="small"
                sx={{
                  height: "35px",
                  borderRadius: "20%",
                  minWidth: "15px",
                  boxShadow: "none",
                }}
                onClick={() => openAplicacoesDialog()}
              >
                <i
                  className="ph-fill ph-circles-three"
                  style={{ color: "#fff", fontSize: 15 }}
                ></i>
              </Button>
            </Tooltip>
          </Grid>
        ) : null}
        {produtosSimilares?.length ? (
          <Grid item xs={0.5} sx={{ mt: "0.5em" }}>
            <Tooltip title="Consultar Similares" placement="bottom">
              <Button
                id="buttonSimilarItem"
                variant="contained"
                color="primary"
                disabled={id || !pedido?.operacaoFiscalId}
                size="small"
                sx={{
                  height: "35px",
                  borderRadius: "20%",
                  minWidth: "15px",
                  boxShadow: "none",
                }}
                onClick={openProdutoSimilar}
              >
                <i
                  className="ph-bold ph-approximate-equals"
                  style={{ color: "#fff", fontSize: 15 }}
                ></i>
              </Button>
            </Tooltip>
          </Grid>
        ) : null}
        <Grid item xs={1}>
          <TextField
            id="estoque"
            name="estoque"
            label="Estoque"
            margin="normal"
            variant={"outlined"}
            disabled
            value={value.text(produto?.estoqueAtual)}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={1}>
          <TextField
            id="unidade"
            name="unidade"
            label="Unidade"
            margin="normal"
            variant={"outlined"}
            disabled
            value={value.text(produto?.unidade)}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={2}>
          <TextField
            id="quantidade"
            name="quantidade"
            label="Quantidade"
            variant={!produto ? "filled" : "outlined"}
            disabled={!produto}
            InputProps={
              produto?.fracionavel
                ? { inputProps: { min: 0.01, step: 0.01 } }
                : { inputProps: { min: 1, step: 1 } }
            }
            value={value.text(produto?.quantidade)}
            onChange={(e) => {
              if (e.target.value <= 0) e.target.value = "";
              if (produto?.fracionavel) {
                e.target.value = Number(e.target.value);
              } else {
                e.target.value = Math.trunc(Number(e.target.value));
              }
              handleInputChange(e);
            }}
            onBlur={handleInputBlur}
            margin="normal"
            type="number"
          />
        </Grid>
        <Grid item xs={2}>
          {acrescimoPagamento > 0 ? (
            <Tooltip
              title={`Esse valor tem acréscimo de ${acrescimoPagamento}% pela condição de pagamento escolhida`}
              placement="top"
            >
              <CurrencyInput
                id="valorUnitario"
                name="valorUnitario"
                label="Valor Unitário R$"
                variant={!produto ? "filled" : "outlined"}
                disabled={!produto || produto?.tipo === "kit"}
                value={value.text(produto?.valorUnitario)}
                onBlur={handleInputBlur}
              />
            </Tooltip>
          ) : (
            <CurrencyInput
              id="valorUnitario"
              name="valorUnitario"
              label="Valor Unitário R$"
              variant={!produto ? "filled" : "outlined"}
              disabled={!produto || produto?.tipo === "kit"}
              value={value.text(produto?.valorUnitario)}
              onBlur={handleInputBlur}
            />
          )}
        </Grid>
        <Grid item xs={2}>
          <CurrencyInput
            id="totalItem"
            name="totalItem"
            label="Total Item R$"
            variant={!produto ? "filled" : "outlined"}
            disabled={!produto || produto?.tipo === "kit"}
            value={value.text(produto?.totalItem)}
            onBlur={handleInputBlur}
          />
        </Grid>
        <Grid item xs={0.5}>
          <IconButton
            variant="contained"
            size="small"
            onClick={handleAddActionsOpen}
          >
            <i
              className="ph-bold ph-caret-down"
              style={{
                color: "#494c62",
                rotate: itensColumnView ? "180deg" : "0deg",
              }}
            ></i>
          </IconButton>
        </Grid>
        <Grid item xs={0.5} sx={{ mt: "0.5em" }}>
          {isProdutoEdit ? (
            <Button
              id="buttonAdicionar"
              variant="contained"
              disabled={id && pedido.status !== "ABERTO"}
              size="small"
              sx={{
                height: "35px",
                borderRadius: "50%",
                minWidth: "15px",
                boxShadow: "none",
              }}
              onClick={() => handleAdicionarProduto(produto)}
            >
              <i
                className="ph-bold ph-arrows-clockwise"
                style={{ color: "#fff", fontSize: 15 }}
              ></i>
            </Button>
          ) : (
            <Tooltip title="Adicionar Produto">
              <Button
                id="buttonAdicionar"
                variant="contained"
                disabled={id && pedido.status !== "ABERTO"}
                color="success"
                size="small"
                sx={{
                  height: "35px",
                  borderRadius: "50%",
                  minWidth: "15px",
                  boxShadow: "none",
                }}
                onClick={() => handleAdicionarProduto(produto)}
              >
                <i
                  className="ph-bold ph-plus"
                  style={{ color: "#fff", fontSize: 15 }}
                ></i>
              </Button>
            </Tooltip>
          )}
        </Grid>
      </Grid>
      {itensColumnView && (
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextFielDecimalNumbers
                  id="descontoPorcentagem"
                  name="descontoPorcentagem"
                  label="Desconto (%)"
                  variant="outlined"
                  disabled={
                    id || !pedido?.descontoItem || produto?.tipo === "kit"
                  }
                  value={produto?.descontoPorcentagem ?? 0}
                  onBlur={handleInputDesconto}
                />
              </Grid>
              <Grid item xs={6}>
                <CurrencyInput
                  id="desconto"
                  name="desconto"
                  label="Desconto (R$)"
                  variant="outlined"
                  disabled={
                    id || !pedido?.descontoItem || produto?.tipo === "kit"
                  }
                  value={produto?.desconto ?? 0}
                  onBlur={handleInputDesconto}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={2}>
            <CurrencyInput
              id="despesas"
              name="despesas"
              label="Despesas"
              disabled={id || !pedido?.despesasItem || produto?.tipo === "kit"}
              value={produto?.despesas ? produto.despesas : ""}
              onBlur={handleInputBlur}
            />
          </Grid>
        </Grid>
      )}
      <Grid container spacing={3}>
        <Grid style={{ marginTop: 32 }} item xs={12}>
          <DataGrid
            style={{ zIndex: 1 }}
            rows={listaPedidosProdutos}
            rowCount={listaPedidosProdutos.length}
            columns={colunas}
            disableAcoes
          />
        </Grid>
      </Grid>
      <Grid
        container
        direction="row-reverse"
        justifyContent="flex-start"
        spacing={2}
        sx={{ mt: 2 }}
      >
        {tabelaCustoPermissao && listaPedidosProdutos.length > 0 && (
          <Grid item xs={2} display="flex" justifyContent="flex-end">
            <Button
              className="mb-3"
              size="large"
              variant="contained"
              color="primary"
              onClick={() => handleOpenTabelaCustoDialog(true)}
            >
              <i
                className="ph-fill ph-table"
                style={{ color: "#fff", fontSize: 22, marginRight: 10 }}
              ></i>
              Tabela de Custo
            </Button>
          </Grid>
        )}
        {ordemCompraPermissao && listaPedidosProdutos.length > 0 && (
          <Grid
            item
            xs={3}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              className="mb-3"
              size="large"
              variant="contained"
              color="primary"
              onClick={() => setOpenOrdemCompraDialog(true)}
            >
              <i
                className="ph-fill ph-hand-coins"
                style={{ color: "#fff", fontSize: 22, marginRight: 10 }}
              ></i>
              Ordem de Compra
            </Button>
          </Grid>
        )}
      </Grid>
      <ProdutoSimilarDialog
        produto={produto}
        openProdutoSimilarDialog={openProdutoSimilarDialog}
        setOpenProdutoSimilarDialog={setOpenProdutoSimilarDialog}
        buscarProdutosSimilares={buscarProdutosSimilares}
        produtosColunasSimilares={produtosColunasSimilares}
        produtosSimilares={produtosSimilares}
      />
      <ProdutoEstoqueInformacaoDialog
        produto={produto}
        open={openProdutoEstoqueInformacaoDialog}
        setOpen={setOpenProdutoEstoqueInformacaoDialog}
        usuario={usuario}
        handleChangeAutocompleteProduto={handleChangeAutocompleteProduto}
      />
      <DocumentoProdutoAplicacaoDialog
        open={openProdutoAplicacoesDialog}
        setOpen={setOpenProdutoAplicacoesDialog}
        aplicacoesProduto={produto?.aplicacoes}
      />
      <TabelaCustoDialog
        openDialog={openTabelaCustoDialog}
        setOpenDialog={setOpenTabelaCustoDialog}
        produtos={produtosTabelaCusto}
        totais={totaisTabelaCusto}
      />
      <OrdemCompraDialog
        openDialog={openOrdemCompraDialog}
        setOpenDialog={setOpenOrdemCompraDialog}
        itens={pedidoEntity.itens}
        produtos={listaPedidosProdutos}
        setProdutos={setListaPedidosProdutos}
      />
    </Grid>
  );
};

export default PedidosItens;
